import { mixins } from 'vue-class-component';
import { HomeViewModel } from './HomeViewModel';
import 'element-plus/theme-chalk/el-loading.css';
export default class Home extends mixins(HomeViewModel) {}